import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@contracts';
import { ApiCilent } from '@core';
import { Observable } from 'rxjs';
type ParameterModule = 'rms' | 'ems';
type KEY = 'location_tier_1' | 'location_tier_2' | 'location_tier_3';
@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(private apiClient: ApiCilent) {}

  getPublicZone(key: KEY, type?: string): Observable<ApiResponse<any>> {
    return this.apiClient.get({
      path: 'locations',
      domain: 'core',
      version: 'v2',
      query: {
        type: type ?? 'public',
        key,
      },
    });
  }

  getPublicGroup(): Observable<ApiResponse<any>> {
    return this.apiClient.get({
      path: 'tags',
      domain: 'core',
      version: 'v1',
      query: {
        tags: 'public',
      },
    });
  }

  getOverview(floor: any): Observable<ApiResponse<any>> {
    return this.apiClient.get({
      path: 'plan',
      domain: 'fast',
      version: 'v1',
      query: { key: 'tier_3', data: floor },
    });
  }

  getParameter(module: ParameterModule = 'rms'): Observable<ApiResponse<any>> {
    return this.apiClient.get({
      path: 'parameters/',
      domain: 'core',
      version: 'v1',
      query: { module },
    });
  }
}
